import { IMarker } from 'src/interfaces/Marker';
import { IPlayerData } from 'src/interfaces/PlayerData';
import { IPlayerParams } from 'src/interfaces/PlayerParams';
import { MARKER_TYPE } from 'src/interfaces/enums';
import { post, put, del } from 'src/utils/apiUtils';
import { MARKER_URL } from './constants';

export interface ICreateMarkerDTO {
  text: string;
  currentTime: number;
  id?: number;
}

class MarkerService {
  private playerData: IPlayerData;
  private playerParams: IPlayerParams;

  constructor(playerData: IPlayerData, params: IPlayerParams) {
    this.playerData = playerData;
    this.playerParams = params;
  }

  generateRequestUrlTo(method: string, params?: unknown) {
    const { reference, signature, code, user } = this.playerData;

    const { token } = this.playerParams;

    switch (method) {
      case 'post':
        return `${MARKER_URL}/${code}?signature=${signature}&application-key=${token}`;
      case 'put':
        return `${MARKER_URL}/${params}/${reference || user}?signature=${signature}&application-key=${token}`;
      case 'delete':
        return `${MARKER_URL}/${params}/${reference || user}`;
      default:
        return '';
    }
  }

  saveMarker({ text, currentTime, id }: ICreateMarkerDTO) {
    const { reference, canEditMarkers: isProducer, user } = this.playerData;

    const type = isProducer ? MARKER_TYPE.MARK : MARKER_TYPE.NOTE;

    const marker: IMarker = {
      userReference: reference || user,
      time: Math.round(currentTime),
      text,
      type
    };

    if (id) {
      marker.id = id;
      return this.updateMarker(marker);
    }

    return this.insertMarker(marker);
  }

  insertMarker = (marker: IMarker): Promise<IMarker> => {
    const uri = this.generateRequestUrlTo('post');

    return post(uri, marker);
  };

  updateMarker = (marker: IMarker) => {
    const uri = this.generateRequestUrlTo('put', marker.id);

    return put(uri, marker);
  };

  deleteMarker(id: number) {
    const uri = this.generateRequestUrlTo('delete', id);

    return del(uri);
  }
}
export default MarkerService;
